import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-campaign-pause-edit-visuals-modal',
    templateUrl: './campaign-pause-edit-visuals-modal.component.html',
    styleUrls: ['./campaign-pause-edit-visuals-modal.component.scss']
})
export class CampaignPauseEditVisualsModalComponent {
    constructor(
        public dialogRef: MatDialogRef<CampaignPauseEditVisualsModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {}

    getTitle() {
        return 'Please make sure to republish your campaign in order to notify your suppliers of any changes and to recalculate your campaign fees. In case any supplier has already paid the municipality fees on your behalf, it will be charged separately. Are you sure you want to pause visuals?';
    }

    proceedToStep4InEditMode(): void {
        this.dialogRef.close({ navigateToStep4: true });
    }
}
